<script>
  import {createEventDispatcher} from 'svelte'
  import {fly} from 'svelte/transition'
  import gsap from 'gsap'
  import VerizonMediaLogo from '../svgs/VerizonMediaLogo.svelte'
  import { scrollPercent } from '../TrackScrollPct'

  export let path = 'intro'
  export let isPathMounting = false
  let progress = 0, scrollY = 0, lastStoredProgress = 0
  
  const dispatch = createEventDispatcher()
  const scrollPoints = [25, 33, 50, 66, 75, 90, 99.25]

  $: if(isPathMounting && path === 'intro' && lastStoredProgress !== 0) {
    lastStoredProgress = 0
  }
  $: if(!isPathMounting && path !== 'intro') {
    gsap.to('header', {backgroundColor: 'black', borderBottomColor: 'var(--gray-line)', duration: .25, ease: 'none'})
  }

  function clickLinear (event) {
    dispatch('path', {name: 'linear'})
	}
  $: if(scrollY > -1000) {
    if(!isPathMounting) {
      window.requestAnimationFrame(() => {
        let pct = scrollY / (document.scrollingElement.scrollHeight - document.body.clientHeight)
        if(isNaN(pct)) pct = 0
        if(path == 'intro') {
          progress = pct * 0.333;
        } else {
          progress = pct * 0.667 + 0.333
        }
        scrollPoints.forEach(pt => {
          const p = progress * 100
          if(p >= pt && lastStoredProgress < pt) {
            lastStoredProgress = pt
            if(pt == scrollPoints[scrollPoints.length-1]) pt = 100
            scrollPercent.set(pt)
          }
        })
      })
    }
  }

	function clickDigital (event) {
    dispatch('path', {name: 'digital'})
	}
  function clickLogo (event) {
    if(path === 'intro') return
    dispatch('path', {name: 'intro'})
  }
</script>
<svelte:window bind:scrollY={scrollY} />

<header>
  <div class="progress" style="transform: scaleX({progress})"></div>
  <div class="inner">
    <button type="button" aria-label="Verizon Media" class="custom logo-btn" on:click|preventDefault={clickLogo}>
      <VerizonMediaLogo />
    </button>
    {#if path !== 'intro'}
      <nav class="menu">
        <button in:fly="{{y: 10, duration: 700}}" out:fly type="button" class="custom" class:active={path === 'linear'} on:click|preventDefault={clickLinear}>Linear TV</button>
        <button in:fly="{{y: 10, duration: 700, delay: 80}}" out:fly="{{delay: 80}}" type="button" class="custom" class:active={path === 'digital'} on:click|preventDefault={clickDigital}>Digital TV</button>
      </nav>
    {/if}
  </div>
</header>

<style>

	header {
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		padding: 16px 0;
		background: black;
		z-index: 999;
    border-bottom: 1px solid var(--gray-line);
	}
 	@media(min-width: 1024px) {
		header {
			padding: 20px 0;
		}
	}
	header :global(svg) {
		height: 47px;
	}
	nav button + button {
		margin-left: 10px;
	}
	nav button {
		position: relative;
		font-size: 14px;
		font-weight: bold;
		color: white;
		padding: 5px;
	}
	nav button:after {
		content: '';
		display: block;
		position: absolute;
		left: 5px;
		width: calc(100% - 10px);
		height: 2px;
		background: var(--verizon-red);
		bottom: 2px;
		transform: scaleX(0);
		transition: 250ms cubic-bezier(0.645, 0.045, 0.355, 1) transform;
	}
	nav button.active:after {
		transform: scaleX(1);
	}
  .logo-btn {
    background: transparent;
    border: 0;
    border-radius: 0;
    margin: 0;
    padding: 0;
  }
  .progress {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 3;
    pointer-events: none;
    width: 100%;
    transition: 300ms cubic-bezier(0.215, 0.610, 0.355, 1) transform;
    height: 4px;
    background: var(--verizon-red);
    transform-origin: top left;
  }
  .inner {
    width: 100%;
    max-width: var(--max-width);
    margin: auto;
    position: relative;
    display: flex;
		justify-content: space-between;
    align-items: center;
  }
</style>